import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAppContext } from '../../contexts/app-guard'

export const Route = createFileRoute('/app/')({
  component: AppIndex,
})

function AppIndex() {
  const { user, memberships } = useAppContext()

  const firstStartup = memberships.find((m) => m.type === 'startup')
  const firstInvestor = memberships.find((m) => m.type === 'investor')

  if (user.userType === 'INVESTOR' && firstInvestor) {
    return <Navigate to="/app/investor/$id" params={{ id: firstInvestor.id }} />
  }

  if (user.userType === 'FOUNDER' && firstStartup) {
    return <Navigate to="/app/startup/$id" params={{ id: firstStartup.id }} />
  }

  return null
}
